import { useQuery } from '@tanstack/react-query';
import { mealCompositionService } from '@/services/mealComposition';
import { MEAL_COMPOSITIONS } from '@/constants/queryKeys';
import { useUser } from '@/contexts/UserContext';

export const useMealCompositions = () => {
  const { user } = useUser();
  
  return useQuery({
    queryKey: [MEAL_COMPOSITIONS],
    queryFn: mealCompositionService.getMealCompositions,
    enabled: !!user,
    staleTime: 2 * 60 * 60 * 1000, // 2 hours
    gcTime: 24 * 60 * 60 * 1000, // 24 hours
  });
};